import { handleGestureEnd } from "./handleGestureEnd";
import { handleMobileKeyboard } from "./handleMobileKeyboard";
import { EventToCanvas } from "./EventToCanvas";
import { prepHandleEvent } from "./prepHandleEvent";
import { Globals } from "../CoreApp/Globals";
import { maybeShowChartBoxClickToolbar } from "./handleMouseUp";

export function handleTouchEnd(event) {
  // in android, we send multi touch events to our gesture event functions for pinch zoom
  if (event.touches.length == 2) {
    handleGestureEnd(event);
  } else if (event.changedTouches.length == 1 && !Globals._gestureActive) {
    var theTouch = event.changedTouches[0];
    var x = theTouch.clientX;
    var y = theTouch.clientY;
    var canvas = document.getElementById("basecanvas");
    var rect = canvas.getBoundingClientRect();
    var p = EventToCanvas({ clientX: x, clientY: y }, rect.left, rect.top);

    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;
    var preInteractMode = myApp.fWSMgr?.fInteractMode;
    myApp.HandleMouseMove(p.x, p.y);
    myApp.HandleMouseUp(p.x, p.y);
    if (event.type === "touchend") maybeShowChartBoxClickToolbar(myApp, preInteractMode);

    handleMobileKeyboard();
    event.preventDefault();
    event.stopPropagation();
  }
}
